<div
        class="preview-card"
        [class.priority-high]="notification.priority === 'high'"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
        (click)="onCardClick($event)">

    <div class="card-content">
        <div class="card-header">
            <span class="card-title" [innerHTML]="formattedTitle">

            </span>

            <span class="card-time">{{ notification.createdAt | date:'shortTime' }}</span>
        </div>
        <div class="card-body">
            {{ notification.body }}
        </div>
    </div>

    <button class="close-btn" (click)="onCloseClick($event)" aria-label="Dismiss">
        &times;
    </button>
</div>